<template>
  <component
    v-if="is"
    :is="is"
    v-bind="props"
  />
</template>

<script>
  import { mapMutations } from 'vuex';

  import Page from '@/api/pages';
  import { studlyCase } from '@/util/strings';

  import ViewPageTeam from './ViewPageTeam';
  import ViewPageContact from './ViewPageContact';
  import ViewPageDefault from './ViewPageDefault';
  import ViewPageFacility from './ViewPageFacility';

  export default {
    components: {
      ViewPageTeam,
      ViewPageContact,
      ViewPageDefault,
      ViewPageFacility,
    },
    props: {
      slug: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        data: undefined,
        template: undefined,
      };
    },
    computed: {
      is() {
        const { template } = this;

        if (template === undefined) {
          return undefined;
        }

        if (template === '') {
          return 'ViewPageDefault';
        }

        return `ViewPage${studlyCase(template)}`;
      },
      props() {
        const { is, data } = this;

        if (!is) {
          return undefined;
        }

        const { cleanProps } = this.$options.components[is];

        if (!cleanProps) {
          return data;
        }

        return cleanProps(data);
      },
    },
    watch: {
      $route: {
        handler: 'fetch',
        immediate: true,
      },
    },
    methods: {
      async fetch() {
        this.data = await Page.where('slug', this.slug).first();

        const {
          template,
          title: {
            rendered: name,
          },
        } = this.data;

        this.template = template;

        this.setViewName(name);
      },
      ...mapMutations(['setViewName']),
    },
  };
</script>

<style
  scoped
  lang="scss"
>

</style>
